import styles from './Login.module.css';
import React, { useState } from "react";
import {
    TextField,
    Button,
    CircularProgress,
    InputAdornment,
    IconButton
} from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import { loginUser } from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import paceLogo from '../../assets//paceLogo.jpg';
import { setUser } from '../../auth/actions';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type FormValues = {
    username: string
    password: string
}

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { dispatch } = useAuth();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<FormValues>();

    const userLogin = async (data: FormValues) => {
        setLoading(true);

        const response = await loginUser(data);

        if (response?.data?.data?.needsPasswordChange) {
            navigate('/change-password', {
                state: {
                    token: response.data.data.accessToken,
                    from: location.state?.from
                }
            });

            setLoading(false);
            return;
        }

        if (response?.data?.success) {
            dispatch(
                setUser({
                    id: response.data.data.id,
                    name: response.data.data.name,
                    surname: response.data.data.surname,
                    emal: response.data.data.email,
                    username: response.data.data.username,
                    token: response.data.data.accessToken,
                })
            );

            setLoading(false);

            // Get the URL the user originally tried to access
            const from = location.state?.from;
            console.log('from', from);
            // Return to the original URL, including query parameters
            navigate(
                from
                    ? `${from.pathname}${from.search}${from.hash}`
                    : '/pace-team/resourcing/resource-tracker',
                { replace: true }
            );
        } else {
            setLoading(false);
            toast.error(response);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.regionsMapImage} />

            <div className={styles.loginForm}>
                <img
                    src={paceLogo}
                    style={{ width: "150px", height: "auto" }}
                    alt="pace-logo"
                />

                <form
                    className={styles.formLogin}
                    onSubmit={handleSubmit(userLogin)}
                >
                    <h2>Sign in to your account</h2>

                    <TextField
                        label="Username"
                        type="text"
                        color="warning"
                        {...register("username", {
                            required: "Username is required"
                        })}
                        error={!!errors.username}
                        helperText={errors.username?.message}
                        style={{
                            margin: '15px',
                            width: '350px',
                            backgroundColor: 'white'
                        }}
                    />

                    <TextField
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        color="warning"
                        {...register("password", {
                            required: "Password is required"
                        })}
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        style={{
                            margin: '15px',
                            width: '350px',
                            backgroundColor: 'white'
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() =>
                                            setShowPassword((prev) => !prev)
                                        }
                                        edge="end"
                                    >
                                        {showPassword
                                            ? <VisibilityOff />
                                            : <Visibility />
                                        }
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Button
                        variant="outlined"
                        type="submit"
                        size="large"
                        disabled={loading}
                        style={{
                            backgroundColor: "#021332",
                            width: '350px',
                            color: 'white',
                            borderColor: '#021332',
                            marginTop: 25
                        }}
                    >
                        {loading
                            ? <CircularProgress
                                size={24}
                                style={{ color: 'white' }}
                              />
                            : ' Log in'
                        }
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;
